import React, {useState, useEffect} from 'react';
import './LoeschungModal.css';
import {formatBetrag, formatCurrencyInput} from '../utils/formatUtils';
import Tooltip from "./ui/Tooltip";
import {IconInfo} from "./ui/Icons";

const LoeschungModal = ({isOpen, onClose, onConfirm, item, mode = 'delete'}) => {
    const [betrag, setBetrag] = useState('');
    const [bemerkung, setBemerkung] = useState('');

    useEffect(() => {
        if (isOpen && item) {
            if (item.betrag !== undefined && item.betrag !== null) {
                // Formatiere den Betrag für die Anzeige (z.B. von "1000.00" zu "1.000,00")
                setBetrag(formatBetrag(item.betrag));
            } else {
                setBetrag('');
            }
            if (mode === 'edit') {
                setBemerkung(item.bemerkung || item.sonstigeBemerkungen || '');
            } else {
                setBemerkung('');
            }
        } else if (isOpen) {
            setBetrag('');
            setBemerkung('');
        }
    }, [isOpen, item, mode]);

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (mode === 'edit' && !betrag) return;
        onConfirm({betrag, bemerkung});
        setBetrag('');
        setBemerkung('');
    };

    const handleClose = () => {
        setBetrag('');
        setBemerkung('');
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const isEdit = mode === 'edit';

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content">
                <div className="modal-header">
                    <h3 className="modal-title">
                        <span>
                            {isEdit ? 'Eintrag ändern ' : 'Eintrag löschen '}
                        </span>
                        {isEdit && (
                            <Tooltip position="bottom" align="right"
                                     text={'Durch die Änderung wird der aktuelle Eintrag\nmit der laufenden Nr. ' +
                                         item.laufendeNr + ' gelöscht und ein\nneuer, aktualisierter Eintrag erstellt.'}>
                                <IconInfo style={{cursor: 'help'}}/>
                            </Tooltip>
                        )}
                    </h3>
                    <button className="modal-close" onClick={handleClose} aria-label="Schließen">
                        ×
                    </button>
                </div>
                <div className="modal-body">
                    <div className="loeschung-modal-content">
                        {item && (
                            <div className="top-block">
                                <div className="top-block-row">
                                    <span className="top-block-label">Laufende Nr.</span>
                                    <span className="top-block-value">{item.laufendeNr}</span>
                                </div>
                                {item.aktenzeichen && (
                                    <div className="top-block-row">
                                        <span className="top-block-label">Aktenzeichen</span>
                                        <span className="top-block-value">{item.aktenzeichen}</span>
                                    </div>
                                )}
                            </div>
                        )}
                        <div className="loeschung-form">
                            <div className="form-group">
                                <label htmlFor="loeschung-betrag">
                                    Betrag {isEdit && <span style={{color: 'red'}}>*</span>}
                                </label>
                                <input
                                    id="loeschung-betrag"
                                    className="form-input"
                                    value={betrag}
                                    onChange={(e) => setBetrag(formatCurrencyInput(e.target.value))}
                                    disabled={!isEdit}
                                    readOnly={!isEdit}
                                    placeholder="z.B. 1.234,56"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="loeschung-bemerkung">
                                    Bemerkung <span className="optional-text">(optional)</span>
                                </label>
                                <textarea
                                    id="loeschung-bemerkung"
                                    className="form-textarea"
                                    onChange={(e) => setBemerkung(e.target.value)}
                                    placeholder={`${isEdit ? 'z.B. Änderungen am Nominalbetrag durch Vertragsänderungen, Nachverhandlungen oder Umschuldungen' : 'z.B. Löschung wegen vollständiger Rückzahlung'}`}
                                    rows="3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        className="modal-btn modal-btn-danger"
                        onClick={handleConfirm}
                        disabled={isEdit && !betrag}
                    >
                        {isEdit ? 'Ändern' : 'Löschen'}
                    </button>
                    <button className="modal-btn modal-btn-secondary" onClick={handleClose}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoeschungModal;
